import React from "react";
import { Calendar } from "lucide-react";

export const toLocalInput = (d) => new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16);

// Choix du jour + heure d'une course programmée (format français).
export default function ScheduleField({ value, onChange, testid = "client-schedule-field" }) {
  const [day, time] = (value || "").split("T");
  const [hh = "12", mm = "00"] = (time || "").split(":");
  const today = new Date();
  const days = Array.from({ length: 31 }, (_, i) => {
    const d = new Date(today.getFullYear(), today.getMonth(), today.getDate() + i);
    return { key: toLocalInput(d).slice(0, 10), d, i };
  });
  const set = (nd, nh, nm) => onChange(`${nd}T${nh}:${nm}`);
  const dayLabel = ({ d, i }) => (i === 0 ? "Auj." : i === 1 ? "Demain" : d.toLocaleDateString("fr-FR", { weekday: "short" }));
  const sel = "h-12 w-full appearance-none rounded-xl bg-white px-3 text-center font-[Outfit] text-[18px] font-black street-border-thin focus:outline-none";
  return (
    <div className="min-w-0 rounded-2xl bg-[#FFF3CC] p-3 street-border-thin street-shadow-sm" data-testid={testid}>
      <span className="flex items-center gap-1.5 text-[11px] font-black uppercase tracking-widest text-foreground/60">
        <Calendar className="h-3.5 w-3.5" /> Jour et heure de prise en charge
      </span>
      <div className="-mx-3 mt-2 flex gap-2 overflow-x-auto px-3 pb-1 no-scrollbar" data-testid="client-schedule-days">
        {days.map((x) => {
          const on = x.key === day;
          return (
            <button
              key={x.key}
              type="button"
              onClick={() => set(x.key, hh, mm)}
              data-testid={`client-schedule-day-${x.key}`}
              className={`flex w-[58px] flex-none flex-col items-center rounded-xl py-1.5 street-border-thin transition-transform duration-150 active:scale-95 ${on ? "bg-primary text-primary-foreground shadow-[0_3px_0_0_#000]" : "bg-white"}`}
            >
              <span className="text-[10px] font-black uppercase leading-none">{dayLabel(x)}</span>
              <span className="mt-0.5 font-[Outfit] text-[19px] font-black leading-none tabular-nums">{x.d.getDate()}</span>
              <span className="text-[9px] font-bold uppercase leading-none opacity-70">{x.d.toLocaleDateString("fr-FR", { month: "short" })}</span>
            </button>
          );
        })}
      </div>
      <div className="mt-2 grid grid-cols-[1fr_auto_1fr] items-center gap-2">
        <select value={hh} onChange={(e) => set(day, e.target.value, mm)} data-testid="client-schedule-hour" className={sel} style={{ fontSize: "18px" }}>
          {Array.from({ length: 24 }, (_, h) => String(h).padStart(2, "0")).map((h) => <option key={h} value={h}>{h} h</option>)}
        </select>
        <span className="font-[Outfit] text-[20px] font-black">:</span>
        <select value={mm} onChange={(e) => set(day, hh, e.target.value)} data-testid="client-schedule-minute" className={sel} style={{ fontSize: "18px" }}>
          {Array.from({ length: 12 }, (_, m) => String(m * 5).padStart(2, "0")).map((m) => <option key={m} value={m}>{m}</option>)}
        </select>
      </div>
      <span className="mt-1.5 block text-[10px] font-semibold text-foreground/55">Entre 1 h et 30 jours à l&apos;avance</span>
    </div>
  );
}
